"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.stageFromString = exports.Stage = void 0;
/**
 * Represents a deployment Stage for the application.
 */
var Stage;
(function (Stage) {
    /**
     * Running in the developer local environment.
     */
    Stage["LOCAL"] = "Local";
    /**
     * Running in Eventbrite dev environment.
     */
    Stage["DEV"] = "Dev";
    /**
     * Running in Eventbrite test environment, also known as QA.
     */
    Stage["TEST"] = "Test";
    /**
     * Running in Eventbrite prod environment.
     */
    Stage["PROD"] = "Prod";
})(Stage = exports.Stage || (exports.Stage = {}));
function stageFromString(stage) {
    switch (stage.toLowerCase()) {
        case "local":
            return Stage.LOCAL;
        case "dev":
            return Stage.DEV;
        case "test":
            return Stage.TEST;
        case "prod":
            return Stage.PROD;
        default:
            throw new Error(`Unknown stage: ${stage}`);
    }
}
exports.stageFromString = stageFromString;
//# sourceMappingURL=Stage.js.map